import 'stylesheets/bootstrap/page/blog_index'
import 'stylesheets/bootstrap/page/blog'
import flatpickr from 'flatpickr';
import "./futureinsurances/articles"

$(function () {
  //設定時間用
  function setTime(time, day, hour, min) {
    time.setDate(time.getDate() + day)
    time.setHours(time.getHours() + hour)
    time.setMinutes(min)
    return time
  }

  //預設出發時間  現在時間往後一個小時的整點
  var defaultStartDate = setTime(new Date(), 0, 2, 0)
  //預設回程時間  現在時間往後五天又一個小時的整點
  var defaultEndDate = setTime(new Date(), 5, 2, 0)
  let dateStart = flatpickr('.date-selection-start', {
    enableTime: true,
    dateFormat: "Y/m/d H:i",
    minDate: setTime(new Date(), 0, 1, 0),
    maxDate: setTime(new Date(), 60, 0, 0),
    defaultDate: defaultStartDate,
    minuteIncrement: 60,
    onChange: function (selectedDates, dateStr, instance) {
      console.log('trigger: start', dateStr)


      end = dateEnd


      //如果出發日選得比返程日還大
      var endDate = end.selectedDates[0].setSeconds(0);
      if (endDate <= selectedDates[0]) {
        //將出發日＋1天設定回返程日
        endDate = setTime(new Date(selectedDates[0]), 1, 0, 0)
        end.setDate(endDate);
        console.log('change', selectedDates);
      }
    }
  });

  window.sss = dateStart

  let dateEnd = flatpickr('.date-selection-end', {
    enableTime: true,
    dateFormat: "Y/m/d H:i",
    minDate: setTime(new Date(), 1, 1, 0),
    defaultDate: defaultEndDate,
    minuteIncrement: 60,
    onChange: function (selectedDates, dateStr, instance) {
      console.log('trigger: end', dateStr)


      start = dateStart


      //如果返程日選得比出發日還小
      var startDate = start.selectedDates[0];
      if (startDate >= selectedDates[0]) {
        //將出發日＋1天設定回返程日
        startDate = setTime(new Date(selectedDates[0]), -1, 0, 0)
        start.setDate(startDate);
        console.log('change', selectedDates);
      }
    }
  });

})